import moment from "moment";
import { ModelBase } from "../abstract/model-base.model";
import { Currency } from "../core/currency.model";

export class AccountStatementTransaction extends ModelBase {

    static override CLASS_NAME: string = 'AccountStatementTransaction';

    private _amount!: number;
    private _amountOrg!: number;
    private _balance!: number;
    private _contentTypeId!: number;
    private _contentTypeModel!: string;
    private _currency!: Currency;
    private _date!: moment.Moment;
    private _description!: string;
    private _lettering!: string;
    private _letteringDate!: moment.Moment;
    private _objectId!: number;
    private _type!: string;

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: any) {
        this._setValue('_amount', value, 'float');
    }

    public get amountOrg(): number {
        return this._amountOrg;
    }

    public set amountOrg(value: any) {
        this._setValue('_amountOrg', value, 'float');
    }

    public get balance(): number {
        return this._balance;
    }

    public set balance(value: any) {
        this._setValue('_balance', value, 'float');
    }

    public get contentTypeId(): number {
        return this._contentTypeId;
    }

    public set contentTypeId(value: any) {
        this._setValue('_contentTypeId', value, 'integer');
    }

    public get contentTypeModel(): string {
        return this._contentTypeModel;
    }

    public set contentTypeModel(value: any) {
        this._setValue('_contentTypeModel', value, 'string');
    }

    public get currency(): Currency {
        return this._currency;
    }

    public set currency(value: any) {
        this._setValue('_currency', value, 'Currency');
    }

    public get date(): moment.Moment {
        return this._date;
    }

    public set date(value: any) {
        this._setValue('_date', value, 'date');
    }

    public get description(): string {
        return this._description;
    }

    public set description(value: any) {
        this._setValue('_description', value, 'string');
    }

    public get lettering(): string {
        return this._lettering;
    }

    public set lettering(value: any) {
        this._setValue('_lettering', value, 'string');
    }

    public get letteringDate(): moment.Moment {
        return this._letteringDate;
    }

    public set letteringDate(value: any) {
        this._setValue('_letteringDate', value, 'date');
    }

    public get objectId(): number {
        return this._objectId;
    }

    public set objectId(value: any) {
        this._setValue('_objectId', value, 'integer');
    }

    public get type(): string {
        return this._type;
    }

    public set type(value: any) {
        this._setValue('_type', value, 'string');
    }

}
